import { useFormContext } from 'react-hook-form';
import { FormTextField } from '../../../../../../design-system/form-text-field/form-text-field';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '../../../../../../design-system/form/form-primitives';
import { Stack } from '../../../../../../design-system/stack/stack';
import { cn } from '../../../../../../utils/cn';

export const SalaryInformation = () => {
  const { control } = useFormContext();

  return (
    <Stack space={6} className="w-full">
      <Stack space={4} className="w-full">
        <h2 className="text-seapoint-gray-900 text-lg font-semibold">
          Salary Information <span className="text-sm text-seapoint-gray-text">(Optional)</span>
        </h2>

        <div className="w-full">
          <FormField
            control={control}
            name="salary"
            render={({ field, formState }) => {
              return (
                <Stack space={1} align="stretch">
                  <FormItem
                    className={cn(
                      'rounded-lg border border-seapoint-gray-border bg-white px-4 py-3 focus-within:outline-none focus-within:ring-2 focus-within:ring-seapoint-yellow focus-within:ring-offset-2 has-[:disabled]:cursor-not-allowed has-[:disabled]:bg-seapoint-gray-background-modal',
                      { 'border-seapoint-red': !!formState.errors.salary },
                    )}
                  >
                    <Stack space={1} align="stretch">
                      <FormLabel className="text-xs font-medium text-seapoint-gray">
                        Annual Pay <span className="text-inherit">(Optional)</span>
                      </FormLabel>

                      <FormControl>
                        <input
                          type="text"
                          inputMode="decimal"
                          autoComplete="off"
                          placeholder="Enter annual pay"
                          className="font-base w-full font-medium text-black placeholder:text-seapoint-gray focus-visible:outline-none disabled:cursor-not-allowed disabled:bg-seapoint-gray-background-modal disabled:placeholder:text-seapoint-gray/80"
                          aria-required={false}
                          {...field}
                          onChange={(e) => {
                            const raw = e.target.value;
                            let sanitized = raw.replace(/[^\d.]/g, '');
                            const firstDot = sanitized.indexOf('.');
                            if (firstDot !== -1) {
                              const before = sanitized.slice(0, firstDot + 1);
                              const after = sanitized
                                .slice(firstDot + 1)
                                .replace(/\./g, '') // remove any additional dots
                                .slice(0, 2); // limit to two decimals
                              sanitized = before + after;
                            }
                            field.onChange(sanitized);
                          }}
                          // Prevents controlled / uncontrolled console warning message
                          value={field.value ?? ''}
                          disabled={field.disabled}
                          data-1p-ignore={false}
                        />
                      </FormControl>
                    </Stack>
                  </FormItem>

                  <FormMessage className="w-full text-right" />
                </Stack>
              );
            }}
          />
        </div>

        <div className="w-full">
          <FormTextField label="Tax ID" inputName="taxId" placeholder="Enter tax ID" isOptional={true} />
        </div>
      </Stack>
    </Stack>
  );
};
